import { RequestState } from '../types';

export type StatusPalette = {
  bg: string;
  color: string;
  border: string;
  dot: string;
};

export const WEB_STATUS_COLORS: Record<string, StatusPalette> = {
  [RequestState.REQUEST_SUBMITTED]: {
    bg: 'var(--sc-info-bg)',
    color: 'var(--sc-info-text)',
    border: 'var(--sc-info)',
    dot: 'var(--sc-info)',
  },
  [RequestState.UNDER_REVIEW]: {
    bg: 'var(--sc-warning-bg)',
    color: 'var(--sc-warning-text)',
    border: 'var(--sc-warning)',
    dot: 'var(--sc-warning)',
  },
  [RequestState.APPROVED]: {
    bg: 'var(--sc-success-bg)',
    color: 'var(--sc-success-text)',
    border: 'var(--sc-success)',
    dot: 'var(--sc-success)',
  },
  [RequestState.ASSIGNED]: {
    bg: 'rgba(124, 58, 237, 0.14)',
    color: '#8B5CF6',
    border: '#8B5CF6',
    dot: '#8B5CF6',
  },
  [RequestState.NEGOTIATING]: {
    bg: 'var(--sc-warning-bg)',
    color: 'var(--sc-warning-text)',
    border: 'var(--sc-warning)',
    dot: 'var(--sc-warning)',
  },
  [RequestState.CONFIRMED]: {
    bg: 'var(--sc-success-bg)',
    color: 'var(--sc-success-text)',
    border: 'var(--sc-success)',
    dot: 'var(--sc-success)',
  },
  [RequestState.CLOSED]: {
    bg: 'var(--sc-bg-hover)',
    color: 'var(--sc-text-secondary)',
    border: 'var(--sc-border)',
    dot: 'var(--sc-text-tertiary)',
  },
  [RequestState.DISPUTED]: {
    bg: 'var(--sc-error-bg)',
    color: 'var(--sc-error-text)',
    border: 'var(--sc-error)',
    dot: 'var(--sc-error)',
  },
  [RequestState.REJECTED]: {
    bg: 'var(--sc-error-bg)',
    color: 'var(--sc-error-text)',
    border: 'var(--sc-error)',
    dot: 'var(--sc-error)',
  },
  [RequestState.CANCELLED]: {
    bg: 'var(--sc-error-bg)',
    color: 'var(--sc-error-text)',
    border: 'var(--sc-error)',
    dot: 'var(--sc-error)',
  },
  DEFAULTED: {
    bg: 'var(--sc-error-bg)',
    color: 'var(--sc-error-text)',
    border: 'var(--sc-error)',
    dot: 'var(--sc-error)',
  },
  OVERDUE: {
    bg: 'var(--sc-warning-bg)',
    color: 'var(--sc-warning-text)',
    border: 'var(--sc-warning)',
    dot: 'var(--sc-warning)',
  },
  VERIFICATION: {
    bg: 'var(--sc-info-bg)',
    color: 'var(--sc-info-text)',
    border: 'var(--sc-info)',
    dot: 'var(--sc-info)',
  },
};

export const getWebStatusPalette = (status?: string): StatusPalette =>
  WEB_STATUS_COLORS[status || ''] || {
    bg: 'var(--sc-bg-input)',
    color: 'var(--sc-text-secondary)',
    border: 'var(--sc-border)',
    dot: 'var(--sc-text-tertiary)',
  };

export const statusBadgeStyle = (status?: string) => {
  const palette = getWebStatusPalette(status);
  return {
    background: palette.bg,
    color: palette.color,
    border: `1px solid ${palette.border}`,
  };
};
